// C:\Users\aleja\Code\inventory_analytics\src\front\src\components\Navbar.jsx

import React, { useContext, useState, useRef, useEffect } from "react";
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";
import { Context } from "../store/appContext";
import { getVisibleNavigation } from "../utils/navigation";
import "../styles/navbar.css";

const Navbar = () => {
  const { store, actions } = useContext(Context);
  const location = useLocation();
  const navigate = useNavigate();

  const [openDropdown, setOpenDropdown] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const navbarRef = useRef();

  const handleLogout = async () => {
    setOpenDropdown(null);
    setMenuOpen(false);
    const result = await actions.logout();

    if (result?.success) {
      navigate("/");
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navbarRef.current && !navbarRef.current.contains(e.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const closeNavigationMenus = () => {
    setMenuOpen(false);
    setOpenDropdown(null);
  };

  const toggleDropdown = (key) => {
    setOpenDropdown((currentKey) => (currentKey === key ? null : key));
  };

  const navigation = getVisibleNavigation({
    isAuthenticated: store.authResolved && store.isAuthenticated,
    role: store.role,
  });
  const isScanner = store.role === "scanner";

  const isGroupActive = (group) =>
    group.items.some((item) => item.to === location.pathname);

  const renderNavItem = (item) => (
    <li className="nav-item" key={item.key}>
      <NavLink
        className={({ isActive }) =>
          "nav-link nav-module-link" + (isActive ? " active" : "")
        }
        to={item.to}
        onClick={closeNavigationMenus}
      >
        <i className={`bi ${item.icon} nav-icon`} aria-hidden="true"></i>
        {item.label}
      </NavLink>
    </li>
  );

  const renderDropdown = (group) => {
    const isOpen = openDropdown === group.key;
    const isActive = isGroupActive(group);

    return (
      <li className="nav-item nav-dropdown" key={group.key}>
        <button
          className={`nav-link nav-module-link nav-dropdown-toggle${
            isActive ? " active" : ""
          }`}
          type="button"
          aria-expanded={isOpen}
          onClick={() => toggleDropdown(group.key)}
        >
          <i className={`bi ${group.icon} nav-icon`} aria-hidden="true"></i>
          {group.label}
          <span className="nav-caret" aria-hidden="true">
            <i className="bi bi-chevron-down"></i>
          </span>
        </button>

        {isOpen && (
          <div className="nav-dropdown-menu">
            {group.items.map((item) => (
              <NavLink
                className={({ isActive }) =>
                  "nav-dropdown-item" + (isActive ? " active" : "")
                }
                to={item.to}
                key={item.key}
                onClick={closeNavigationMenus}
              >
                <i
                  className={`bi ${item.icon} nav-dropdown-icon`}
                  aria-hidden="true"
                ></i>
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        )}
      </li>
    );
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark sticky-top main-navbar"
      ref={navbarRef}
    >
      <div className="container">
        <Link className="navbar-brand app-brand" to="/">
          <span className="brand-mark" aria-hidden="true">
            <i className="bi bi-boxes"></i>
          </span>
          <span className="brand-copy">
            <span className="brand-name">Analítica de Inventario</span>
            <span className="brand-tagline">Inventario y métricas</span>
          </span>
        </Link>

        {/* BOTÓN MOBILE */}
        <button
          className="navbar-toggler"
          type="button"
          aria-label="Abrir navegación"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* MENÚ */}
        <div className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}>
          {/* LINKS */}
          <ul className="navbar-nav ms-auto nav-main">
            {navigation.links.map(renderNavItem)}
            {navigation.groups.map(renderDropdown)}

            {!store.isAuthenticated && (
              <li className="nav-item">
                <Link
                  className="nav-link nav-module-link"
                  to="/login"
                  onClick={closeNavigationMenus}
                >
                  <i className="bi bi-shield-lock nav-icon" aria-hidden="true"></i>
                  Iniciar sesión
                </Link>
              </li>
            )}
          </ul>

          {/* USUARIO SEPARADO */}
          {store.isAuthenticated && isScanner && (
            <ul className="navbar-nav nav-user">
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    "nav-link nav-module-link" + (isActive ? " active" : "")
                  }
                  to="/change-password"
                  onClick={closeNavigationMenus}
                >
                  <i className="bi bi-key nav-icon" aria-hidden="true"></i>
                  Cambiar contraseña
                </NavLink>
              </li>
              <li className="nav-item">
                <button
                  className="nav-link nav-module-link scanner-logout-btn"
                  type="button"
                  onClick={handleLogout}
                >
                  <i className="bi bi-box-arrow-right nav-icon" aria-hidden="true"></i>
                  Cerrar sesión
                </button>
              </li>
            </ul>
          )}

          {store.isAuthenticated && !isScanner && (
            <ul className="navbar-nav nav-user">
              <li className="nav-item user-dropdown">
                <button
                  className="user-btn"
                  type="button"
                  aria-expanded={openDropdown === "user"}
                  onClick={() => toggleDropdown("user")}
                >
                  <i className="bi bi-person-circle" aria-hidden="true"></i>
                  <span className="username">{store.username || "Usuario"}</span>
                  <span className="nav-caret" aria-hidden="true">
                    <i className="bi bi-chevron-down"></i>
                  </span>
                </button>

                {openDropdown === "user" && (
                  <div className="user-menu">
                    <NavLink to="/change-password" onClick={closeNavigationMenus}>
                      <i className="bi bi-key" aria-hidden="true"></i>
                      Cambiar contraseña
                    </NavLink>
                    <button type="button" onClick={handleLogout}>
                      <i className="bi bi-box-arrow-right" aria-hidden="true"></i>
                      Cerrar sesión
                    </button>
                  </div>
                )}
              </li>
            </ul>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
